
export default function FollowCTA() {
  return (
    <>
      <hr />
      <p>
        <i>
          For more project updates, follow Wren on{' '}
          <a
            href="https://twitter.com/project_wren"
            target="_blank"
            rel="noopener noreferrer"
          >
            X (formerly Twitter)
          </a>{' '}
          and{' '}
          <a
            href="https://www.instagram.com/project_wren"
            target="_blank"
            rel="noopener noreferrer"
          >
            Instagram
          </a>
          .
        </i>
      </p>
      <hr />
    </>
  );
}
